import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/appLogs/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/appLogs/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/appLogs/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/appLogs/delete',
    method: 'post',
    data
  })
}

